module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/0b86251491d9b9cc0fb87d40dd26db0e.png";